import { CheckupRequestInfo } from '@companion-professional/dctypes';

// SURVEY_CHECKUP_PARAM is the query parameter on the new survey page that holds the ids of the checkup requests to
// attach to the survey. It may be repeated to attach more than one checkup request.
export const SURVEY_CHECKUP_PARAM = 'checkup';

// getNewSurveyPath returns the path to fill out a new survey for a pet, with the given checkup requests pre-selected to
// be attached to the survey. Because the checkup request ids are in the URL, the path works as a direct link from
// outside vPortal.
export const getNewSurveyPath = (petId: string, surveyId: string, checkupRequestIds: string[] = []) => {
  const params = new URLSearchParams();
  checkupRequestIds.forEach((id) => params.append(SURVEY_CHECKUP_PARAM, id));
  const query = params.toString();
  return `/pets/${petId}/survey/${surveyId}${query ? `?${query}` : ''}`;
};

// getSurveyPathForCheckup returns the path a user should go to when they choose a survey for a checkup request: the
// saved answers (which can be edited) if the survey has already been answered for that checkup request, otherwise a new
// survey with the checkup request pre-selected.
export const getSurveyPathForCheckup = (surveyId: string, checkupRequest: CheckupRequestInfo) => {
  const answered = checkupRequest.answered_surveys?.find((s) => s.survey_id === surveyId);
  if (answered) {
    return `/pets/${checkupRequest.pet_id}/answers/${answered.answers_id}`;
  }
  return getNewSurveyPath(checkupRequest.pet_id, surveyId, [checkupRequest.id]);
};
